
<div class="post-item" :data-id="post.id">
  <linkable-item
    v-if="post"
    :as="is"
    :target="post.link ? '_blank' : '_self'"
    :to="isPublic ? `/feed/post/${post.id}` : { query: { ...$route.query, postId: post.id } }"
    :href="post.link"
    rel="noopener noreferrer"
  >
    <div class="post">
      <img v-if="post.image" v-lazy="{ src: post.image }" />

      <div v-else-if="post.category" :class="['icon-wrapper', post.category.toLowerCase()]">
        <icon class="icon" :name="icon" />
      </div>

      <div class="post-content">
        <align flex direction="flex-start">
          <div class="post-title">{{ post.title }}</div>

          <icon-button
            v-if="isAdmin"
            tooltip="Delete post"
            icon="delete_outline"
            @click.stop.prevent="$emit('deletePost', post.id)"
          />
        </align>

        <p class="bottom-row">
          <span>{{ post.creator || 'Card Ladder' }}</span>
          <span>{{ timestamp }}</span>
        </p>
      </div>
    </div>
  </linkable-item>
</div>
